import { render, staticRenderFns } from "./Sstages.vue?vue&type=template&id=22cedb4f&scoped=true"
import script from "./Sstages.vue?vue&type=script&lang=js"
export * from "./Sstages.vue?vue&type=script&lang=js"
import style0 from "./Sstages.vue?vue&type=style&index=0&id=22cedb4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cedb4f",
  null
  
)

export default component.exports